<!--
Author: TangChen
Date: 2019-10-23
Desc: 信息登记
 -->
<template>
    <div :class="'view-org-register view bg-white ' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="org-form">
            <el-form
                ref="orgInfo"
                :model="orgInfo"
                :rules="rules"
                label-width="370px"
                class="bankInfo"
                v-on:submit.native.prevent
            >
                <div class="el-form-item text-form">
                    <label class="el-form-item__label" style="width: 370px;">
                        受益人(
                        <el-tooltip
                            class="item"
                            effect="info"
                            placement="bottom-start"
                            :offset="-200"
                        >
                            <div slot="content">
                                <p v-for="(item,i) in CUST" :key="i" class="list" :class="item.substr(0,1).indexOf('*')>-1?'main':''" v-text="item"></p>
                            </div>
                            <span class="explain secondary">什么是受益人
                                <i class="fa fa-question-circle"></i>
                            </span>
                        </el-tooltip>
                        )：
                    </label>
                    <div class="el-form-item__content" style="margin-left: 370px;">
                        <div class="el-input intro-bar">
                            (此处填写的受益人信息，请保持与贵司上传的信息一致)
                        </div>
                    </div>
                </div>
                <el-form-item label="是否存在受益人：" prop="existbenef">
                    <el-radio-group v-model="orgInfo.existbenef">
                        <el-radio v-for="item in isBeneficiary" :key="item.subitem" :label="item.subitem">
                            {{ item.subitemname }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="受益人所属类型：" prop="custorgtype">
                    <el-select
                        v-model.trim="orgInfo.custorgtype"
                        filterable
                        placeholder="请选择受益人所属类型"
                    >
                        <el-option
                            v-for="item in $cache.getDict('120125')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="受益人类型：" prop="beneficiarytype">
                    <el-select
                        v-model.trim="orgInfo.beneficiarytype"
                        filterable
                        placeholder="请选择受益人类型"
                    >
                        <el-option
                            v-for="item in $cache.getDict('120126')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="实际受益人证件类型：" prop="benefcertype" class="two-cols">
                    <el-select
                        v-model.trim="orgInfo.beneficiaryinvtp"
                        placeholder="请选择证件类型"
                    >
                        <el-option
                            v-for="item in beneficiaryinvtp||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model.trim="orgInfo.benefcertype"
                        filterable
                        placeholder="请选择实际受益人证件类型"
                    >
                        <el-option
                            v-for="item in instreprtype1"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="实际受益人证件号码：" prop="benefcerno">
                    <el-input v-model.trim="orgInfo.benefcerno" placeholder="请输入实际受益人证件号码" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="证件有效期：" prop="beneficiarydate">
                    <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="实际受益人名称：" prop="beneficiaryname">
                    <el-input v-model.trim="orgInfo.beneficiaryname" placeholder="请输入实际受益人名称" :maxlength="20" />
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="控制权结构证明：" prop="controlstructure">
                    <el-select
                        v-model.trim="orgInfo.controlstructure"
                        filterable
                        placeholder="请选择控制权结构证明"
                    >
                        <el-option
                            v-for="item in $cache.getDict('110045')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='0'" label="资金来源：" prop="assetssource">
                    <el-input v-model.trim="orgInfo.assetssource" placeholder="请输入资金来源" :maxlength="30" />
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='1'" label="豁免原因：" prop="exemption">
                    <el-select
                        v-model.trim="orgInfo.exemption"
                        filterable
                        placeholder="请选择豁免原因"
                    >
                        <el-option
                            v-for="item in $cache.getDict('120124')||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <!--<el-input v-model.trim="orgInfo.exemption" placeholder="请输入豁免原因" :maxlength="30" />-->
                </el-form-item>
                <el-form-item v-if="orgInfo.existbenef==='2'" label="其他原因：" prop="otherreason">
                    <el-input v-model.trim="orgInfo.otherreason" placeholder="请输入其他原因" :maxlength="30" />
                </el-form-item>
                <!--法定代表人-->
                <div class="line-pad">
                    <div class="bt-white"></div>
                </div>
                <div class="el-form-item text-form">
                    <label class="el-form-item__label" style="width: 370px;">
                        法定代表人(
                        <el-tooltip
                            class="item"
                            effect="info"
                            placement="bottom-start"
                            :offset="-200"
                        >
                            <div slot="content">
                                <p v-for="(item,i) in INSTREPR" :key="i" class="list" v-text="item"></p>
                            </div>
                            <span class="explain secondary">什么是法定代表人
                                <i class="fa fa-question-circle"></i>
                            </span>
                        </el-tooltip>
                        )：
                    </label>
                    <div class="el-form-item__content" style="margin-left: 370px;">
                        <div class="el-input intro-bar">
                            (此处填写的法定代表信息，请保持与贵司上传的信息一致)
                        </div>
                    </div>
                </div>
                <el-form-item label="姓名：" prop="instreprname">
                    <el-input v-model.trim="orgInfo.instreprname" placeholder="请输入姓名" :maxlength="30" />
                </el-form-item>
                <el-form-item label="证件类型：" prop="instrepridtype" class="two-cols">
                    <el-select
                        v-model.trim="orgInfo.instreprtype"
                        placeholder="请选择证件类型"
                    >
                        <el-option
                            v-for="item in instreprtype||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model.trim="orgInfo.instrepridtype"
                        filterable
                        placeholder="请选择证件类型"
                    >
                        <el-option
                            v-for="item in instreprtype2"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="证件号码：" prop="instrepridcode">
                    <el-input v-model.trim="orgInfo.instrepridcode" placeholder="请输入证件号码" :maxlength="18" />
                </el-form-item>
                <el-form-item v-if="dateSet1.max" label="证件有效期：" prop="instreprvailddate">
                    <date-picker :date="dateSet1" v-on:date-get="insDateInterval" />
                </el-form-item>
                <!--控股股东或实际控制人信息-->
                <div class="line-pad">
                    <div class="bt-white"></div>
                </div>
                <div class="el-form-item text-form">
                    <label class="el-form-item__label" style="width: 370px;">
                        股东或实际控制人是否为法人(
                        <el-tooltip
                            class="item"
                            effect="info"
                            placement="bottom-start"
                            :offset="-200"
                        >
                            <div slot="content">
                                <p v-for="(item,i) in CONTROLER" :key="i" class="list" v-text="item"></p>
                            </div>
                            <span class="explain secondary">什么是控制人
                                <i class="fa fa-question-circle"></i>
                            </span>
                        </el-tooltip>
                        )：
                    </label>
                    <div class="el-form-item__content" style="margin-left: 370px;">
                        <div class="el-input intro-bar">
                            <el-radio-group v-model="isControler">
                                <el-radio label="1">
                                    是
                                </el-radio>
                                <el-radio label="2">
                                    否
                                </el-radio>
                                <el-radio label="3">
                                    无控制人
                                </el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div v-if="isControler==='2'" class="controler">
                    <el-form-item label="姓名：" prop="majoritystakename">
                        <el-input v-model.trim="orgInfo.majoritystakename" placeholder="请输入姓名" :maxlength="30" />
                    </el-form-item>
                    <el-form-item label="证件类型：" prop="minvtp" class="two-cols">
                        <el-select
                            v-model.trim="orgInfo.minvtp"
                            placeholder="请选择证件类型"
                        >
                            <el-option
                                v-for="item in minvtp||[]"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                        <el-select
                            v-if="orgInfo.minvtp==='0'"
                            v-model.trim="orgInfo.omcertificatetype1"
                            class="last-sel"
                            filterable
                            placeholder="请选择证件类型"
                        >
                            <el-option
                                v-for="item in $cache.getDict('130008')||[]"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="orgInfo.minvtp==='1'"
                            v-model.trim="orgInfo.omcertificatetype2"
                            class="last-sel"
                            filterable
                            placeholder="请选择证件类型"
                        >
                            <el-option
                                v-for="item in $cache.getDict('130007')||[]"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="证件号码：" prop="omcertificateno">
                        <el-input v-model.trim="orgInfo.omcertificateno" placeholder="请输入证件号码" :maxlength="18" />
                    </el-form-item>
                    <el-form-item v-if="dateSet2.max" label="证件有效期：" prop="holdingidvalidate">
                        <date-picker :date="dateSet2" v-on:date-get="holdDateInterval" />
                    </el-form-item>
                </div>
                <el-form-item class="margin-top">
                    <el-button type="yellow" class="medium" v-on:click.prevent="submitForm('orgInfo')">
                        下一步
                    </el-button>
                    <el-button class="medium" type="back" v-on:click.prevent="$router.back()">
                        返回
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import navBar from "@/components/common/navBar.vue";
import datePicker from "@/components/common/datePicker.vue";
export default {
    name: "ViewOrgRegister",
    components: {
        navBar,
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            navs: [
                {id: "1",val: "经办人信息"},
                {id: "2",val: "基本信息"},
                {id: "3",val: "信息登记",active: "1"},
                {id: "4",val: "银行信息"},
                {id: "5",val: "文件上传"},
                {id: "6",val: "完成注册",icon: "fa fa-check"}
            ],
            orgInfo: {
                existbenef: "",
                custorgtype: "",
                beneficiarytype: "",
                benefcertype: "",
                benefcerno: "",
                beneficiarydate: "",
                beneficiaryname: "",
                controlstructure: "0",
                assetssource: "",
                remark: "",
                otherreason: "",
                exemption: "",
                instreprname: "",
                instrepridtype: "",
                instrepridcode: "",
                instreprvailddate: "",
                majoritystakename: "",
                minvtp: "0",
                instreprtype: "0",
                beneficiaryinvtp: "0",
                omcertificatetype1: "",
                omcertificatetype2: "",
                omcertificateno: "",
                holdingidvalidate: ""
            },
            minvtp: [{ id: "0", name: "机构证件" }, { id: "1", name: "个人证件" }],
            instreprtype: [],
            beneficiaryinvtp: [],
            instreprtype1: [],
            instreprtype2: [],
            rules: {
                existbenef: [
                    { required: true, message: "请选择是否存在受益人", trigger: "change" }
                ],
                custorgtype: [
                    { required: true, message: "请选择受益人所属类型", trigger: "change" }
                ],
                beneficiarytype: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                benefcertype: [
                    { required: true, message: "请选择实际受益人证件类型", trigger: "change" }
                ],
                benefcerno: [
                    { validator: this.checkCertNo, trigger: "change" }
                ],
                beneficiarydate: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                beneficiaryname: [
                    { validator: this.checkName, trigger: "change" }
                ],
                controlstructure: [
                    { required: true, message: "控制权结构证明", trigger: "change" }
                ],
                assetssource: [
                    { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                remark: [
                    { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                exemption: [
                    { required: true, message: "请选者豁免原因", trigger: "change" }
                ],
                otherreason: [
                    { required: true, message: "请输入其他原因", trigger: "change" },
                    { validator: this.$util.validateCCharacter, trigger: "change" }
                ],
                instreprname: [
                    { validator: this.checkName, trigger: "change" }
                ],
                instrepridtype: [
                    { required: true, message: "请选择证件类型", trigger: "change" }
                ],
                instrepridcode: [
                    { validator: this.insCheckCertNo, trigger: "change" }
                ],
                instreprvailddate: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ],
                majoritystakename: [
                    { validator: this.checkName, trigger: "change" }
                ],
                minvtp: [
                    { validator: this.checkCardType, trigger: "change" }
                ],
                omcertificateno: [
                    { validator: this.holdCheckCertNo, trigger: "change" }
                ],
                holdingidvalidate: [
                    { required: true, message: "请选择证件有效期", trigger: "change" }
                ]
            },
            isBeneficiary: [],
            dateSet: { type: "3", max: "", dis: false, val: "",text: "请选择证件有效期" },
            dateSet1: {},
            dateSet2: {},
            INSTREPR: "",
            CONTROLER: "",
            dis: false,//是否开启ocr
            CUST: "",
            isControler: "2"

        };
    },
    watch: {
        "orgInfo.benefcerno"(val){
            if(this.orgInfo.beneficiaryinvtp == "1" && this.orgInfo.benefcertype === "0" && val.indexOf("x") > -1){
                this.$set(this.orgInfo,"benefcerno",val.replace("x","X"));
            }
        },
        "orgInfo.instrepridcode"(val){
            if(this.orgInfo.instreprtype == "1" && this.orgInfo.instrepridtype === "0" && val.indexOf("x") > -1){
                this.$set(this.orgInfo,"instrepridcode",val.replace("x","X"));
            }
        },
        "orgInfo.omcertificateno"(val){
            if(this.orgInfo.minvtp === "1" && this.orgInfo.omcertificatetype2 === "0" && val.indexOf("x") > -1){
                this.$set(this.orgInfo,"omcertificateno",val.replace("x","X"));
            }
        },
        "orgInfo.instreprtype"(val){
            this.orgInfo.instrepridtype = "";
            if (this.orgInfo.instreprtype == 0) {
                this.instreprtype2 = this.$cache.getDict("130008") || [];
            }else {
                this.instreprtype2 = this.$cache.getDict("130007") || [];
            }
        },
        "orgInfo.beneficiaryinvtp"(val){
            this.orgInfo.benefcertype = "";
            if (this.orgInfo.beneficiaryinvtp == 0) {
                this.instreprtype1 = this.$cache.getDict("130008") || [];
            }else {
                this.instreprtype1 = this.$cache.getDict("130007") || [];
            }
        }
    },
    mounted() {
        this.isBeneficiary = this.$cache.getDict("120123") || [];
        this.instreprtype = this.$cache.getDict("150138") || [];
        this.beneficiaryinvtp = this.$cache.getDict("150138") || [];
        this.instreprtype1 = this.orgInfo.beneficiaryinvtp == 0 ? this.$cache.getDict("130008") : this.$cache.getDict("130007") || [];
        this.instreprtype2 = this.orgInfo.instreprtype == 0 ? this.$cache.getDict("130008") : this.$cache.getDict("130007") || [];
        this.orgInfo.existbenef = this.isBeneficiary[0] ? this.isBeneficiary[0].subitem : "";
        const conf = this.$util.getConfig().const;
        this.INSTREPR = conf.INSTREPR;
        this.CONTROLER = conf.CONTROLER;
        this.CUST = conf.CUST;
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.dateSet1 = Object.assign({},this.dateSet);
        this.dateSet2 = Object.assign({},this.dateSet);
        if(this.$store.state.login.status && !this.$util.isEmpty(this.$cache.getUser().invtp)){
            return this.getHasInfo();
        }
        const _t = sessionStorage.getItem("_t") || "";
        if(_t){
            return this.getOpenInfo(_t);
        }
    },
    methods: {
        getHasInfo(){
            const _this = this;
            this.$util.request("orgopen/refuse/info").then(res=>{
                if(res.data){
                    _this.initData(res.data[0]);
                }
            });
        },
        // 初始化缓存信息
        getOpenInfo(val){
            const _this = this;
            this.$util.request("orgopen/step",{transid: val}).then(res=>{
                if(res.data){
                    if(!_this.$util.isEmpty(res.data[0].existbenef)){
                        _this.initData(res.data[0]);
                    }
                }
            });
        },
        initData(info){
            if(info.invtp){
                let _x = {
                    existbenef: info.existbenef,
                    instreprname: info.instreprname,
                    instrepridtype: info.instrepridtype,
                    instrepridcode: info.instrepridcode,
                    instreprvailddate: info.instreprvailddate,
                    exemption: info.otherreason,
                    otherreason: info.otherreason
                };
                this.$set(this.dateSet1,"val",this.$util.fmtDate(info.instreprvailddate));
                if(info.existbenef === "0"){
                    const _e = {
                        custorgtype: info.custorgtype,
                        beneficiarytype: info.beneficiarytp,
                        benefcertype: info.benefcertype,
                        benefcerno: info.benefcerno,
                        beneficiarydate: info.beneficiarydate,
                        beneficiaryname: info.beneficiaryname,
                        controlstructure: info.controlstructure,
                        assetssource: info.assetssource
                    };
                    _x = Object.assign({},_x,_e);
                    this.$set(this.dateSet,"val",this.$util.fmtDate(info.beneficiarydate));
                }
                if(this.$util.isEmpty(info.majoritystakename)){
                    this.isControler = "3";
                }else{
                    if(info.instreprname === info.majoritystakename &&
                        info.instrepridtype === info.omcertificatetype &&
                        info.instrepridcode === info.omcertificateno &&
                        info.instreprvailddate === info.holdingidvalidate){
                        this.isControler = "1";
                    }else{
                        this.isControler = "2";
                    }
                    const _c = {
                        majoritystakename: info.majoritystakename,
                        minvtp: info.minvtp,
                        omcertificatetype1: info.minvtp === "0" ? info.omcertificatetype : "",
                        omcertificatetype2: info.minvtp === "0" ? "" : info.omcertificatetype,
                        omcertificateno: info.omcertificateno,
                        holdingidvalidate: info.holdingidvalidate
                    };
                    this.$set(this.dateSet2,"val",this.$util.fmtDate(info.holdingidvalidate));
                    _x = Object.assign({},_x,_c);
                }

                this.orgInfo = Object.assign({},this.orgInfo,_x);
            }
        },
        submitForm(name){
            const _this = this;
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if(_this.orgInfo.existbenef === "0"){
                        _this.specificNaturalper(val=>{
                            if((val === "1" && _this.orgInfo.beneficiarytype && _this.orgInfo.beneficiarytype !== "0") || val === "0"){
                                _this.refreshInfo();
                            }else{
                                _this.$alert("受益人类型错误，请重新选择！", "受益人类型提示", {
                                    confirmButtonText: "确认",
                                    type: "warning"
                                });
                            }
                        });
                        return;
                    }
                    _this.refreshInfo();
                } else {
                    return false;
                }
            });
        },
        // 更新信息
        refreshInfo(){
            const _this = this;
            const _x = Object.assign({},this.orgInfo);
            let refuse = JSON.parse(sessionStorage.getItem("refuse") || "{}");
            refuse.isControler = this.isControler;
            sessionStorage.setItem("refuse",JSON.stringify(refuse));
            const _data = {
                transid: this.$store.state.login.transid,
                existbenef: _x.existbenef,
                custorgtype: _x.existbenef === "0" ? _x.custorgtype : "",
                beneficiarytp: _x.existbenef === "0" ? _x.beneficiarytype : "",
                benefcertype: _x.existbenef === "0" ? _x.benefcertype : "",
                benefcerno: _x.existbenef === "0" ? _x.benefcerno : "",
                beneficiarydate: _x.existbenef === "0" ? _x.beneficiarydate : "",
                beneficiaryname: _x.existbenef === "0" ? _x.beneficiaryname : "",
                beneficiaryaddress: "",
                controlstructure: _x.existbenef === "0" ? _x.controlstructure : "",
                assetssource: _x.existbenef === "0" ? _x.assetssource : "",
                otherreason: _x.existbenef === "0" ? "" : (_x.existbenef === "1" ? _x.exemption : _x.otherreason),
                remark: "",
                instreprname: _x.instreprname,
                instrepridtype: _x.instrepridtype,
                instrepridcode: _x.instrepridcode,
                instreprvailddate: _x.instreprvailddate,
                majoritystakename: this.isControler === "3" ? "" : (this.isControler === "1" ? _x.instreprname : _x.majoritystakename),
                minvtp: this.isControler === "3" ? "" : (this.isControler === "1" ? "1" : _x.minvtp),
                instreprtype: _x.instreprtype,
                beneficiaryinvtp: _x.beneficiaryinvtp,
                omcertificatetype: this.isControler === "3" ? "" : (this.isControler === "1" ? _x.instrepridtype : (_x.minvtp === "0" ? _x.omcertificatetype1 : _x.omcertificatetype2)),
                omcertificateno: this.isControler === "3" ? "" : (this.isControler === "1" ? _x.instrepridcode : _x.omcertificateno),
                holdingidvalidate: this.isControler === "3" ? "" : (this.isControler === "1" ? _x.instreprvailddate : _x.holdingidvalidate),
            };
            this.$util.request("orgopen/save/otherinfo",_data,"POST").then(res=>{
                if(res.data){
                    _this.$router.push({name: "bankinfo"});
                }
            });

        },
        //反洗钱235受益人类型判断
        specificNaturalper(cb){
            let _data = {
                certificatetype: this.orgInfo.benefcertype,
                certificateno: this.orgInfo.benefcerno,
                custfullname: this.orgInfo.beneficiaryname
            };
            this.$util.request("orgopen/search/specifybenec",_data).then(res=>{
                if(res.data){
                    if(cb){
                        cb.call(this,res.data[0].isspecify);
                    }
                }
            });
        },
        /* 校验用户姓名 */
        checkName (rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                this.$util.validateName(rule, value, callback);
            }
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            let flag = false;
            if (this.orgInfo.beneficiaryinvtp == "1" && this.orgInfo.benefcertype == "0") {
                flag = true;
            }else {
                flag = false;
            }
            this.$util.validateCertNo(rule, value, callback, this.orgInfo.benefcertype,flag);
        },
        insCheckCertNo(rule, value, callback) {
            let flag = false;
            if (this.orgInfo.instreprtype == "1" && this.orgInfo.instrepridtype == "0") {
                flag = true;
            }else {
                flag = false;
            }
            this.$util.validateCertNo(rule, value, callback, this.orgInfo.instrepridtype,flag);
        },
        holdCheckCertNo(rule, value, callback) {
            if(this.orgInfo.minvtp === "1"){
                this.$util.validateCertNo(rule, value, callback, this.orgInfo.omcertificatetype2,true);
            }else{
                this.$util.validateCertNo(rule, value, callback, this.orgInfo.omcertificatetype1);
            }

        },
        // 校验证件
        checkCardType(rule, value, callback){
            if(value === "0"){
                if(this.orgInfo.omcertificatetype1 === ""){
                    callback(new Error("请选择证件类型"));
                }
            }else if(value === "1"){
                if(this.orgInfo.omcertificatetype2 === ""){
                    callback(new Error("请选择证件类型"));
                }
            }else{
                callback(new Error("请选择证件类型"));
            }
            if(this.orgInfo.omcertificateno !== ""){
                this.$refs.orgInfo.validateField("omcertificateno");
            }
            callback();
        },
        dateInterval (val) {
            this.orgInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.orgInfo.validateField("beneficiarydate");
        },
        insDateInterval (val) {
            this.orgInfo.instreprvailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.orgInfo.validateField("instreprvailddate");
        },
        holdDateInterval (val) {
            this.orgInfo.holdingidvalidate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.orgInfo.validateField("holdingidvalidate");
        }
    }
};
</script>
<style lang="scss">
    .view-org-register {
        margin-top: 5px;
        padding: 10px 55px;
        .org-form{
            .el-select{width: 50%;}
            .two-cols .el-select{width: 24%;&:last-child,&.last-sel{margin-left: 2%;}}
        }
        /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
